import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let CompanyQueriesService = class CompanyQueriesService {
    constructor(packageApi, productApi, privilegeDataService, i18n, productService, accountService) {
        this.packageApi = packageApi;
        this.productApi = productApi;
        this.privilegeDataService = privilegeDataService;
        this.i18n = i18n;
        this.productService = productService;
        this.accountService = accountService;
    }
    getPackageName(item) {
        return this.privilegeDataService.getPackageName(item);
    }
    getProductName(item) {
        if (this.i18n.locale === 'cn') {
            return item.alias_cn;
        }
        return item.alias_en;
    }
    getPackages() {
        return this.packageApi.getPackageInfoList();
    }
    async getProducts() {
        const products = await this.productService.getProductionProducts();
        return products;
    }
};
CompanyQueriesService = __decorate([
    injectable(),
    __param(0, inject(Symbols.PackageApi)),
    __param(1, inject(Symbols.ProductApi)),
    __param(2, inject(Symbols.PrivilegeDataService)),
    __param(3, inject(Symbols.I18n)),
    __param(4, inject(Symbols.ProductService)),
    __param(5, inject(Symbols.ServiceAccountQueries)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object])
], CompanyQueriesService);
export { CompanyQueriesService };
